export const formatScore = (score) => {
	let comp = parseFloat(score);

	if (comp % 1 > 0) {
		return comp;
	} else {
		return comp.toFixed(0);
	}
}